var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container p-x-1:mo m-y-5"},[_c('app-login-form',{staticClass:"m-x-auto",attrs:{"redirect-to":this.$route.query.redirect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }